import styled from "@emotion/styled"
import { sizer } from "@ninjaone/utils"
import { Box } from "@ninjaone/webapp/src/js/includes/components/Styled"
import { StyledGrid } from "./Styled"
import ButtonGroup from "./ButtonGroup"
import TitleGroup from "./TitleGroup"
import { VARIANTS } from "./Button"

function getModalWidth(size) {
  switch (size) {
    case "lg":
      return "3 / -3"
    case "md":
      return "4 / -4"
    case "sm":
    default:
      return "5 / -5"
  }
}

const StyledModalDialogBackground = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(33, 31, 51, 0.5);
  overflow-y: hidden;
  z-index: 2050;
  min-width: 1024px;
  height: 100vh;
`
const Grid = styled(StyledGrid)`
  grid-template-rows: ${({ scrollable }) =>
    `minmax(${sizer(13)}, 1fr) ${scrollable ? `minmax(${sizer(100)}, auto)` : "auto"} minmax(${sizer(13)}, 1fr)`};
  place-content: center;
`
const StyledButtonGroup = styled(ButtonGroup)`
  width: 100%;
`
const StyledModalDialog = styled.div`
  grid-row: 2;
  grid-column: ${({ size }) => getModalWidth(size)};
  display: grid;
  grid-auto-flow: row;
  grid-auto-rows: ${({ scrollable }) => (scrollable ? "auto" : "min-content")};
  justify-items: start;
  padding: ${sizer(5)};
  grid-row-gap: ${sizer(4)};
  background-color: ${({ theme }) => theme.color.background};
  border-radius: ${sizer(1)};
  ${({ scrollable }) => scrollable && "overflow: hidden;"}
`

export default function Modal({
  children,
  buttons = [],
  unmount,
  titleGroup,
  size = "sm",
  cancelable,
  buttonRenderer,
  scrollable = false,
  id,
}) {
  return (
    <StyledModalDialogBackground {...{ id }}>
      <Grid {...{ scrollable }}>
        <StyledModalDialog {...{ size, scrollable }} data-test-id="modal">
          {titleGroup && <TitleGroup {...titleGroup} textWrap />}
          <Box width="100%" {...{ ...(scrollable && { overflow: "auto" }) }} data-test-id="confirmation-desc">
            {children}
          </Box>
          {buttonRenderer?.() ?? (
            <StyledButtonGroup
              buttons={[
                { type: cancelable ? "cancel" : "close", onClick: unmount, variant: VARIANTS.SECONDARY },
                ...buttons,
              ]}
            />
          )}
        </StyledModalDialog>
      </Grid>
    </StyledModalDialogBackground>
  )
}
